"use client";
import Image from "next/image";
import { useEffect, useState, useRef } from "react";
import styles from "./generator.module.scss";

export default function Product({ data }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const parseOccasion = (occasion) => {
    switch (occasion) {
      case "christmas":
        return "🎄";
      case "birthday":
        return "🎂";
      case "move":
        return "🏡";
      case "mothersday":
        return "🤱";
      case "fathersday":
        return "👨‍🍼";
      case "marriage":
        return "💍";
      case "honeymoon":
        return "🥂";
      case "party":
        return "🥳";
      case "student":
        return "🇸🇪";
      case "retirement":
        return "👵🏻👴🏻";
      case "pet":
        return "🐱🐶";
      case "valentine":
        return "💖";
    }
  };

  const ctaTexts = [
    "🎁 Ge bort denna present",
    "🛍️ Köp denna present",
    "🎉 Överraska någon idag",
    "💝 Gör någon glad - köp nu",
    "🎀 Skäm bort någon speciell",
  ];
  const [ctaText, setCtaText] = useState("");

  useEffect(() => {
    setCtaText(ctaTexts[Math.floor(Math.random() * ctaTexts.length)]);
  }, []);

  return (
    <div className={styles.product} ref={ref}>
      {visible && (
        <div className={styles.productInnerWrapper}>
          {data?.images && (
            <div className={styles.imageWrapper}>
              <img
                src={data.images[0]}
                alt={data?.alt[0] || "Produktbild"}
                // Note: width/height here helps Next.js/Browser with aspect ratio
                width="640"
                height="640"
                key={data?.alt[0]}
              />
            </div>
          )}
          <div className={styles.info}>
            <div>
              <h3>{data?.product}</h3>
              <p>
                {data?.description?.[0]?.content ? (
                  <>
                    {data.description[0].content.slice(0, 200)}
                    {data.description[0].content.length > 200 ? "..." : ""}
                  </>
                ) : (
                  "" // Or leave empty: ""
                )}{" "}
                <a
                  href={`/presenter/${data?.slug}`}
                  className={styles.readMoreLink}
                >
                  Läs mer...
                </a>
              </p>
            </div>

            <div className={styles.cta}>
              <a
                className={`ctaBtn ctaBtnSecondary`}
                href={data?.link}
                rel="nofollow sponsored"
                target="_blank"
              >
                {ctaText || "🎁 Ge bort denna present"}
              </a>
            </div>
          </div>
          <div className={styles.logoAndTarget}>
            <div className={styles.imageContainer}>
              {" "}
              {/* Added wrapper */}
              <Image
                src={data?.logo || "/fallback-logo.png"}
                alt={`${data?.advertiser}'s logotyp`}
                width={320}
                height={150}
                priority={false}
              />
            </div>
            <div className={styles.priceTarget}>
              <div className={styles.row}>
                <p>Pris</p>
                <p>
                  {data?.price?.min === data?.price?.max
                    ? `${data.price.min} kr`
                    : `${data.price.min} kr - ${data.price.max} kr`}
                </p>
              </div>
              <div className={styles.row}>
                <p>Tillfälle</p>
                <p>{data?.occasion.map((occ) => parseOccasion(occ))}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
